"use client";

import { useState, useEffect } from "react";
import { LoadingLottie } from "../LoadingLottie";

interface InfiniteScrollProps {
  fetchData: () => void;
  isLastPage: boolean;
}

export const InfiniteScroll = ({ fetchData, isLastPage }: InfiniteScrollProps) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    if (isLastPage) {
      window.removeEventListener("scroll", handleScroll);
      setLoading(false);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isLastPage]);

  const handleScroll = () => {
    if (window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight) {
      loadMoreData();
    }
  };

  const loadMoreData = async () => {
    if (loading) return;

    setLoading(true);
    try {
      fetchData();
    } catch (error) {
      throw new Error("::COUPONS::INFINITE__SCROLL", { cause: error });
    }
  };

  return <div>{loading && <LoadingLottie width={32} height={32} />}</div>;
};
